module.exports = __webpack_public_path__ + "static/img/93031C_2_3_R_20200404_LC.db3ef29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/93031C_2_3_R_20200404_LC.png
// module id = ExjA
// module chunks = 0